/* Presentation-only enhancements: no app settings, review records or page writes. */
(function () {
  'use strict';
  function contactLinks() {
    var root = document.querySelector('[data-ffg-contact]');
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [], node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement.closest('a, script, style')) nodes.push(node);
    }
    nodes.forEach(function (text) {
      var pattern = /\(416\)\s*999-6500|info@floresflowershop\.com/g;
      var match, offset = 0, fragment = document.createDocumentFragment();
      while ((match = pattern.exec(text.data))) {
        fragment.appendChild(document.createTextNode(text.data.slice(offset, match.index)));
        var link = document.createElement('a');
        link.textContent = match[0];
        link.href = match[0].includes('@') ? 'mailto:' + match[0] : 'tel:+14169996500';
        fragment.appendChild(link);
        offset = pattern.lastIndex;
      }
      if (offset) {fragment.appendChild(document.createTextNode(text.data.slice(offset))); text.replaceWith(fragment);}
    });
    root.querySelectorAll('a[href]').forEach(function (link) {
      if (!link.textContent.trim() && !link.children.length && !link.getAttribute('aria-label') && !link.getAttribute('aria-labelledby') && !link.title) link.remove();
    });
  }
  var reviewStates = new WeakMap();
  var approvedExcerpts = {
    'Judith Millwood-Mcwhinney': 'Ruby has been an amazing partner in providing individualized gifts for our ladies. They provide excellent service.',
    'Michelle Da Costa': 'Our reception was absolutely stunning... straight out of a dream! Perfection.'
  };
  function reviewElement(tag, className, text) {
    var element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    return element;
  }
  function reviewCarousel(grid, navigation, initialIndex) {
    var cards = Array.from(grid.children), perPage = 0, starts = [], page = 0, width = 0, requested = null;
    var previous = reviewElement('button', '', '←'); previous.type = 'button'; previous.setAttribute('aria-label', 'Previous reviews');
    var next = reviewElement('button', '', '→'); next.type = 'button'; next.setAttribute('aria-label', 'Next reviews');
    var dots = reviewElement('div', 'ffg-review-dots');
    var status = reviewElement('p', 'ffg-review-page-status visually-hidden'); status.setAttribute('aria-live', 'polite');
    navigation.append(previous, dots, next, status);
    grid.setAttribute('role', 'region'); grid.setAttribute('aria-roledescription', 'carousel'); grid.setAttribute('aria-label', 'Customer reviews');
    function offset(index) {return cards[index].offsetLeft - cards[0].offsetLeft;}
    function range(start) {var end = Math.min(start + perPage, cards.length); return start + 1 === end ? 'Review ' + end : 'Reviews ' + (start + 1) + '–' + end;}
    function update(index) {
      page = index;
      cards.forEach(function (card, i) {if (i < starts[page] || i >= starts[page] + perPage) card.querySelector('details').open = false;});
      Array.from(dots.children).forEach(function (dot, i) {if (i === page) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');});
      var text = range(starts[page]);
      if (status.textContent !== text) status.textContent = text;
    }
    function go(index, immediate) {
      index = (index + starts.length) % starts.length;
      requested = index;
      update(index);
      grid.scrollTo({left: offset(starts[index]), behavior: immediate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    function layout() {
      if (width === grid.clientWidth && perPage) return;
      var first = perPage ? starts[page] || 0 : initialIndex || 0;
      width = grid.clientWidth; perPage = matchMedia('(max-width: 749px)').matches ? 1 : 2;
      starts = Array.from({length: Math.ceil(cards.length / perPage)}, function (_, i) {return Math.max(0, Math.min(i * perPage, cards.length - perPage));});
      dots.replaceChildren();
      starts.forEach(function (start, index) {
        var dot = reviewElement('button', '', '•'); dot.type = 'button';
        dot.setAttribute('aria-label', 'Show ' + range(start).toLowerCase());
        dot.addEventListener('click', function () {go(index);}); dots.appendChild(dot);
      });
      cards.forEach(function (card, i) {card.style.scrollSnapAlign = starts.includes(i) ? 'start' : 'none';});
      navigation.hidden = starts.length < 2;
      go(Math.min(Math.floor(first / perPage), starts.length - 1), true);
    }
    previous.addEventListener('click', function () {go(page - 1);}); next.addEventListener('click', function () {go(page + 1);});
    grid.addEventListener('pointerdown', function () {requested = null;}, {passive: true});
    grid.addEventListener('wheel', function () {requested = null;}, {passive: true});
    grid.addEventListener('scroll', function () {
      if (requested !== null) {
        if (Math.abs(grid.scrollLeft - offset(starts[requested])) < 2) requested = null;
        else return;
      }
      var nearest = 0;
      starts.forEach(function (start, i) {if (Math.abs(grid.scrollLeft - offset(start)) < Math.abs(grid.scrollLeft - offset(starts[nearest]))) nearest = i;});
      if (nearest !== page) update(nearest);
    }, {passive: true});
    grid.addEventListener('focusin', function (event) {
      var index = cards.indexOf(event.target.closest('.ffg-review-card'));
      if (index >= 0 && (index < starts[page] || index >= starts[page] + perPage)) go(Math.min(Math.floor(index / perPage), starts.length - 1), true);
    });
    var observer = new ResizeObserver(layout); observer.observe(grid); layout();
    var cleanup = function () {observer.disconnect(); navigation.remove();};
    cleanup.firstIndex = function () {return starts[page] || 0;};
    return cleanup;
  }
  function enhanceReviews(root) {
    var source = root.querySelector('.srs_slider');
    if (!source) return;
    var reviews = [], seen = new Set();
    source.querySelectorAll('.wprevpro_t1_DIV_1').forEach(function (card) {
      var text = card.querySelector('.wprevpro_t1_P_3');
      var authorNode = card.querySelector('.wprevpro_t1_SPAN_5');
      if (!text || !text.textContent.trim() || !authorNode) return;
      var authorCopy = authorNode.cloneNode(true);
      authorCopy.querySelectorAll('.wprev_showdate_T1').forEach(function (date) {date.remove();});
      var author = authorCopy.textContent.trim();
      if (!author) return;
      var full = text.textContent.trim();
      if (author === 'Chrissan Pascal-Clovis') full = full.replace('she mae me feel relaxed', 'she made me feel relaxed');
      var key = JSON.stringify([author, full]);
      if (seen.has(key)) return; // The app may clone slides for carousel looping.
      seen.add(key);
      var starImage = card.querySelector('.wprevpro_t1_star_img_file');
      var rating = starImage && /^([1-5]) star rating$/i.exec((starImage.getAttribute('alt') || '').trim());
      reviews.push({author: author, full: full, key: key, rating: rating ? Number(rating[1]) : 0});
    });
    if (!reviews.length) return; // Keep the original as fallback until data arrives.
    var signature = JSON.stringify(reviews.map(function (review) {return [review.key, review.rating];}).sort());
    var previous = reviewStates.get(root);
    if (previous && previous.signature === signature && previous.grid.isConnected) return;
    // Shuffle only the initial app payload, not every mutation, resize or click.
    if (!previous) {
      for (var i = reviews.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temporary = reviews[i]; reviews[i] = reviews[j]; reviews[j] = temporary;
      }
    } else {
      function position(review) {
        var index = previous.reviews.findIndex(function (old) {return old.key === review.key || old.author === review.author;});
        return index < 0 ? previous.reviews.length : index;
      }
      reviews.sort(function (a, b) {return position(a) - position(b);});
    }
    var opened = new Set();
    var focused;
    if (previous) previous.grid.querySelectorAll('details').forEach(function (detail, index) {
      if (detail.open) opened.add(previous.reviews[index].key);
      if (detail.contains(document.activeElement)) focused = previous.reviews[index].key;
    });
    var grid = reviewElement('div', 'ffg-review-grid');
    reviews.forEach(function (review) {
      var card = reviewElement('article', 'ffg-review-card');
      card.setAttribute('aria-label', 'Review from ' + review.author);
      var rating = reviewElement('p', 'ffg-review-rating', review.rating ? '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating) : '');
      if (review.rating) {rating.setAttribute('role', 'img'); rating.setAttribute('aria-label', review.rating + ' out of 5 stars');}
      else rating.setAttribute('aria-hidden', 'true');
      card.appendChild(rating);
      var quote = reviewElement('blockquote', 'ffg-review-excerpt');
      var excerpt = approvedExcerpts[review.author];
      quote.appendChild(reviewElement('p', '', excerpt && review.full.includes(excerpt) ? excerpt : review.full));
      card.appendChild(quote);
      card.appendChild(reviewElement('p', 'ffg-review-author', review.author));
      var details = document.createElement('details');
      details.open = opened.has(review.key);
      var summary = reviewElement('summary', '', 'Read full review');
      summary.appendChild(reviewElement('span', 'visually-hidden', ' from ' + review.author));
      details.appendChild(summary);
      details.appendChild(reviewElement('p', 'ffg-review-full', review.full));
      card.appendChild(details);
      grid.appendChild(card);
      if (focused === review.key) summary.dataset.restoreFocus = 'true';
    });
    if (previous && previous.cleanup) previous.cleanup();
    if (previous && previous.grid.isConnected) previous.grid.replaceWith(grid);
    else root.appendChild(grid);
    var navigation = reviewElement('div', 'ffg-review-controls'); root.appendChild(navigation);
    var state = {signature: signature, grid: grid, reviews: reviews};
    reviewStates.set(root, state);
    root.classList.add('ffg-reviews-enhanced');
    source.classList.add('ffg-review-source');
    source.hidden = true; // Hide the entire old carousel INCLUDING empty pagination.
    var initialKey = focused || (previous && previous.cleanup && previous.reviews[previous.cleanup.firstIndex()].key);
    state.cleanup = reviewCarousel(grid, navigation, Math.max(0, reviews.findIndex(function (review) {return review.key === initialKey;})));
    var focusTarget = grid.querySelector('[data-restore-focus]');
    if (focusTarget) focusTarget.focus({preventScroll: true});
  }
  function cleanReviews(root) {
    root.querySelectorAll('.wprevpro_t1_DIV_1').forEach(function (card) {
      var text = card.querySelector('.wprevpro_t1_P_3');
      if (!text) return;
      // Stars/author alone are not a text testimonial. Keep the record untouched
      // and allow a later app rerender to restore a newly populated card.
      card.classList.toggle('ffg-empty-review', !text.textContent.trim());
    });
    enhanceReviews(root);
  }
  function start() {
    contactLinks();
    document.querySelectorAll('.srs-testimonial-container').forEach(function (root) {
      cleanReviews(root);
      new MutationObserver(function () {cleanReviews(root);}).observe(root, {childList: true, subtree: true, characterData: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
